import "#/legacy/jquery-global.js";
import "#/legacy/globals.js";
import "#legacy/admin.js";
import "#/admin/tabs/default-tab.js";
import "#/admin/legacy/remote-form-confirmation.js";

// VITE_MIGRATION: flush the ready queue after all legacy globals are loaded
window.Sparkle?.flushReady();
